import React from "react";
import { Link } from "react-router-dom";
import { useLanguage } from "../contexts/LanguageContext";

export const BrandMark = () => (
  <svg viewBox="0 0 32 32" fill="none" aria-hidden="true">
    <path d="M6 23 17 5h9L15 23H6Z" fill="currentColor" />
    <path d="m17 27 9-15v15h-9Z" fill="currentColor" opacity=".5" />
  </svg>
);

export default function Brand() {
  const { t } = useLanguage();
  return (
    <Link className="brand" to="/" aria-label={t("Say it sorted home")}>
      <BrandMark />
      <span>
        sayit<span className="brand-light">sorted</span>
        <span className="brand-period">.</span>
      </span>
    </Link>
  );
}
